/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ItemValue } from './itemValue';
import type { Extras } from './extras';

export interface Item {
  key: string;
  label: string;
  value: ItemValue;
  extras: Extras;
}
